var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[(_vm.role === 'super-admin')?_c('dashboard-admin'):_vm._e(),(_vm.role === 'provider')?_c('dashboard-provider'):_vm._e(),(_vm.role === 'institution-representative')?_c('DashboardRepresentative'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }